import Vue from "vue";
import Router, { Route } from "vue-router";
import { decode } from "jwt-simple";
import store from "@/store";
import {permissions, ptfFeatures} from "@/Constants";
import _ from "lodash";
import Auth from "front-component/Auth";
import RequestForm from "@/components/forms/request/RequestForm.vue";
import RequestNotificationPage from "@/components/admin/notification/RequestNotificationPage.vue";
import SocleNotificationPage from "@/components/admin/notification/SocleNotificationPage.vue";
import RequestNotificationList from "@/components/admin/notification/RequestNotificationList.vue";
import SocleNotificationList from "@/components/admin/notification/SocleNotificationList.vue";
import EditNotificationSocle from "@/components/admin/notification/EditNotificationSocle.vue";
import EditNotificationRequest from "@/components/admin/notification/EditNotificationRequest.vue";
import SocleNotificationApprovalWorkflowPage from "@/components/admin/notification/SocleNotificationApprovalWorkflow/SocleNotificationApprovalWorkflowPage.vue";
import SocleNotificationApprovalWorkflowList from "@/components/admin/notification/SocleNotificationApprovalWorkflow/SocleNotificationApprovalWorkflowList.vue";
import SocleNotificationApprovalWorkflowEdit from "@/components/admin/notification/SocleNotificationApprovalWorkflow/SocleNotificationApprovalWorkflowEdit.vue";
const Token = () => import(/* webpackChunkName: "group-token" */"./views/Token.vue");
const ForgottenPassword = () =>
    import(/* webpackChunkName: "group-forgotten-password" */"./views/ForgottenPassword.vue");
const ResetPassword = () =>
    import(/* webpackChunkName: "group-forgotten-password" */"./views/ResetPassword.vue");
const AppComponent = () => import(/* webpackChunkName: "group-app" */"./views/App.vue");
const LoginRedirect = () => import("./views/LoginRedirect.vue");
const Home = () => import(/* webpackChunkName: "group-app" */"./views/Home.vue");
const PageNotFound = () => import(/* webpackChunkName: "group-page-not-found" */"./views/PageNotFound.vue");
const Unauthorized = () => import(/* webpackChunkName: "group-page-not-found" */"./views/Unauthorized.vue");
const OwnerReportDisabled = () =>
    import(/* webpackChunkName: "group-page-disabled" */"./views/OwnerReportDisabled.vue");
const RequestList = () => import(/* webpackChunkName: "group-request" */"./views/request/List.vue");
const Report = () => import(/* webpackChunkName: "group-budget" */"./views/report/Report.vue");
const InsertionList = () => import(/* webpackChunkName: "group-insertion" */"./views/insertion/List.vue");
const Document = () => import(/* webpackChunkName: "group-insertion" */"./views/insertion/DocumentList.vue");
const AdminTitleList = () => import(/* webpackChunkName: "group-admin" */"./views/admin/request/Title.vue");
const AdminRequestClientList = () => import(/* webpackChunkName: "group-admin" */"./views/admin/request/Client.vue");
const AdminOwnerReportsList = () => import(/* webpackChunkName: "group-admin" */"./components/admin/OwnerReports.vue");
const AdminTopicList = () => import(/* webpackChunkName: "group-admin" */"./views/admin/Topic.vue");
const AdminNotificationManager = () =>
    import(/* webpackChunkName: "group-admin" */"./views/admin/AdminNotificationManager.vue");
const AdminTabsList = () => import(/* webpackChunkName: "group-admin" */"./views/admin/budget/Tabs.vue");
const AdminLineCheck = () => import(/* webpackChunkName: "group-admin" */"./views/admin/linecheck/LineCheck.vue");
const AdminOwnerManager = () => import(/* webpackChunkName: "group-admin" */"./views/admin/OwnerManager.vue");

const ZeroWasteList = () => import(/* webpackChunkName: "operation" */"./views/zero-waste/List.vue");
const SocleList = () => import(/* webpackChunkName: "operation" */"./views/socle/List.vue");
const SocleParticipationList = () => import(/* webpackChunkName: "operation" */"./views/socle/ParticipationList.vue");

const CatalogList = () => import(/* webpackChunkName: "operation" */"./views/zero-waste/CatalogList.vue");

const CompetitorList = () => import(/* webpackChunkName: "competitor" */"./views/competitor/List.vue");

Vue.use(Router);

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        // Document
        { path: "/download-zip", name: "download_zip"},
        // Token
        { path: "/token", name: "token", component: Token },
        {
            path: "/",
            component: AppComponent,
            children: [
                {
                    path: "/redirect",
                    name: "redirect",
                    component: LoginRedirect,
                },
                {
                    path: "/unauthorized",
                    name: "unauthorized",
                    component: Unauthorized,
                },
                {
                    path: "/",
                    name: "home",
                    component: Home,
                    meta: { feature: ptfFeatures.homepage, default: true },
                },
                {
                    path: "/request",
                    name: "requests_list",
                    component: RequestList,
                    props: { defaultRequestUuid: null },
                    meta: { feature: ptfFeatures.request, default: true },
                },
                {
                    path: "/report",
                    name: "report",
                    component: Report,
                    meta: { feature: ptfFeatures.report, default: true },
                },
                {
                    path: "/billing",
                    name: "insertion_list",
                    component: InsertionList,
                    meta: { feature: ptfFeatures.billing, default: true },
                },
                {
                    path: "/billing/document",
                    name: "insertion_document_list",
                    component: Document,
                    meta: { feature: ptfFeatures.billing, default: true },
                },
                {
                    path: "/compensation",
                    name: "surpression_compensation_list",
                    component: ZeroWasteList,
                    meta: { feature: ptfFeatures.zero_waste, default: true },
                },
                {
                    path: "/socle",
                    name: "socle_list",
                    component: SocleList,
                    meta: { feature: ptfFeatures.socle, default: true },
                },
                {
                    path: "/competitor",
                    name: "competitor_list",
                    component: CompetitorList,
                    meta: {
                        feature: ptfFeatures.competitor,
                        default: true,
                        requiredPermission: permissions.competitorAccess
                    },
                },
                {
                    path: "/socle/participation",
                    name: "socle_participation_list",
                    component: SocleParticipationList,
                    meta: { feature: ptfFeatures.socle, default: true },
                },
                // Admin
                { path: "/admin/request/title", name: "admin_request_title_list", component: AdminTitleList },
                {
                    path: "/admin/request/clients",
                    name: "admin_request_client_list",
                    component: AdminRequestClientList
                },
                {
                    path: "/admin/compensation/catalog",
                    name: "admin_compensation_catalog_list",
                    component: CatalogList
                },
                { path: "/admin/owner/reports", name: "admin_owner_reports_list", component: AdminOwnerReportsList },
                { path: "/admin/topic", name: "admin_topic_list", component: AdminTopicList },
                {
                    path: "/admin/lineCheck",
                    name: "admin_line_check",
                    component: AdminLineCheck
                },
                {
                    path: "/admin/notification",
                    component: AdminNotificationManager,
                    name: "admin_notification_manager",
                    children: [
                        {
                            path: "request",
                            component: RequestNotificationPage,
                            children: [
                                {
                                    path: "",
                                    name: "notifications_request_list",
                                    component: RequestNotificationList
                                },
                                {
                                    path: "create",
                                    name: "notifications_request_create",
                                    component: EditNotificationRequest,
                                },
                                {
                                    path: "edit/:uuid",
                                    name: "notifications_request_edit",
                                    component: EditNotificationRequest,
                                }
                            ]
                        },
                        {
                            path: "socle",
                            component: SocleNotificationPage,
                            children: [
                                {
                                    path: "",
                                    name: "notifications_socle_list",
                                    component: SocleNotificationList
                                },
                                {
                                    path: "create",
                                    name: "notifications_socle_create",
                                    component: EditNotificationSocle
                                },
                                {
                                    path: "edit/:uuid",
                                    name: "notifications_socle_edit",
                                    component: EditNotificationSocle
                                }
                            ]
                        },
                        {
                            path: "socle-approval-workflow",
                            component: SocleNotificationApprovalWorkflowPage,
                            children: [
                                {
                                    path: "",
                                    name: "notifications_socle_approval_workflow_list",
                                    component: SocleNotificationApprovalWorkflowList
                                },
                                {
                                    path: "create",
                                    name: "notifications_socle_approval_workflow_create",
                                    component: SocleNotificationApprovalWorkflowEdit
                                },
                                {
                                    path: "edit/:uuid",
                                    name: "notifications_socle_approval_workflow_edit",
                                    component: SocleNotificationApprovalWorkflowEdit
                                }
                            ]
                        },
                    ],
                },
                { path: "/admin/budget", name: "admin_budget_budget_list", component: AdminTabsList },
                { path: "/admin/owner", name: "admin_owner_attributes", component: AdminOwnerManager },
                {
                    path: "/request/new",
                    name: "new_request",
                    component: RequestForm,
                },
                {
                    path: "/request/:uuid",
                    name: "edit_request",
                    component: RequestForm,
                },


                // No authentication requires
                {
                    path: "/forgotten-password",
                    name: "forgotten_password",
                    component: ForgottenPassword,
                    meta: { requiresAuth: false }
                },
                {
                    path: "/reset-password",
                    name: "reset_password",
                    component: ResetPassword,
                    meta: { requiresAuth: false }
                },
                // Not found
                { path: "*", name: "page_not_found", component: PageNotFound },
                { path: "*", name: "owner_report_disabled", component: OwnerReportDisabled },
            ]
        },
    ],
});

router.beforeEach(async (to: Route, from: Route, next: any) => {
    const accessToken: string | null = Auth.getAccessToken();
    if (accessToken && !store.getters.getCurrentUser) {
        try {
            const token = decode(accessToken, "", true);
            if (token.exp <= (new Date()).getTime() / 1000) {
                Auth.disconnect();
            } else {
                if (from.name !== "token") {
                    await store.dispatch("fetchCurrentUserData");
                }
            }
        } catch (error) {
            Auth.disconnect();
        }
    }

    if (to.query.changeOwner) {
        store.dispatch("loadOwners").then(() => {
            store.dispatch("changeCurrentOwner", to.query.changeOwner).then(() => {
                const cleanedRoute = Object.assign({}, to);
                _.unset(cleanedRoute, "query.changeOwner");
                next(cleanedRoute);
            }).catch((reason) => next({path: "/"}));
        }).catch((reason) => {
            next({path: "/"});
        });
    } else {
        next();
    }
});

router.beforeEach((to: Route, from: Route, next: any) => {
    // Check permissions if required
    if (to.meta?.requiredPermission
      && !store.getters.hasPermission(to.meta.requiredPermission)
    ) {
        return next({ name: "unauthorized" }); // Redirect to an error page
    }
    next();
});

export default router;
